import { render } from "./unstyled-text.vue?vue&type=template&id=19b4124e"
import script from "./unstyled-text.vue?vue&type=script&lang=js"
export * from "./unstyled-text.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__